module.exports = __webpack_public_path__ + "static/media/terms001.11c3fbbd.png";